// src/data/BattleCardsData.js
// Complete Battle Cards Database for BUMFIT - Cleaned Version
// Part 1: Core Constants & Types

export const CARD_RARITIES = {
    COMMON: { name: 'Common', color: '#808080', borderColor: '#606060' },
    UNCOMMON: { name: 'Uncommon', color: '#00ff88', borderColor: '#00cc6a' },
    RARE: { name: 'Rare', color: '#0080ff', borderColor: '#0066cc' },
    EPIC: { name: 'Epic', color: '#8000ff', borderColor: '#6600cc' },
    LEGENDARY: { name: 'Legendary', color: '#ff8000', borderColor: '#cc6600' },
    MYTHIC: { name: 'Mythic', color: '#ff0080', borderColor: '#cc0066' }
};

export const CARD_TYPES = {
    TRAINER: 'Train',
    BUILD: 'Build',
    BATTLE: 'Battle',
    MOVE: 'Move',
    HERO: 'Hero',
    VILLAIN: 'Villain',
    EQUIPMENT: 'Equipment',
    TECHNIQUE: 'Technique',
    SPECIAL: 'Special'
};

export const GAME_MODES = {
    ONLINE: 'online',
    OFFLINE: 'offline',
    HYBRID: 'hybrid'
};

export const DIFFICULTY_LEVELS = {
    'Beginner': { multiplier: 1, color: '#2ecc71' },
    'Intermediate': { multiplier: 1.2, color: '#f39c12' },
    'Advanced': { multiplier: 1.5, color: '#e74c3c' },
    'Expert': { multiplier: 2, color: '#9b59b6' }
};

export const MUSCLE_GROUPS = [
    { name: "chest", code: "e" },
    { name: "back", code: "k" },
    { name: "shoulder", code: "h" },
    { name: "arm", code: "m" },
    { name: "bicep", code: "i" },
    { name: "tricep", code: "t" },
    { name: "forearm", code: "f" },
    { name: "legs", code: "g" },
    { name: "abs", code: "a" },
    { name: "calves", code: "v" },
    { name: "trap", code: "p" },
    { name: "quad", code: "q" },
    { name: "hamstring", code: "n" },
    { name: "glute", code: "u" },
    { name: "hip", code: "j" },
    { name: "thigh", code: "y" },
    { name: "oblique", code: "z" },
    { name: "overall", code: "!" }
];// Part 2: Image Paths & Utilities

const CARD_IMAGE_PATHS = {
    MOVE: '/assets/cards/move-cards/',
    TRAIN: '/assets/cards/train-cards/',
    BATTLE: '/assets/cards/battle-cards/',
    BUILD: '/assets/cards/build-cards/',
    BACKS: '/assets/cards/card-backs/'
};

export const AVAILABLE_IMAGES = {
    MOVE_CARDS: [
        'earth1.png', 'earth14.png', 'earth15.png', 'earth17.png', 'earth21.png', 'earth23.png',
        'earth28.png', 'earth29.png', 'earth3.png', 'earth31.png', 'earth32.png', 'earth34.png',
        'earth36.png', 'earth37.png', 'earth40.png', 'earth41.png', 'earth42.png', 'earth43.png',
        'earth9.png', 'fire1.png', 'fire10.png', 'fire12.png', 'fire14.png', 'fire18.png',
        'fire20.png', 'fire21.png', 'fire22.png', 'fire24.png', 'fire31.png', 'fire32.png',
        'fire33.png', 'fire34.png', 'fire35.png', 'fire37.png', 'fire38.png', 'fire40.png',
        'fire42.png', 'fire44.png', 'fire5.png', 'fire50.png', 'fire57.png', 'fire58.png',
        'fire62.png', 'fire63.png', 'fire7.png', 'fire8.png', 'forest1.png', 'forest12.png',
        'forest13.png', 'forest15.png', 'forest16.png', 'forest17.png', 'forest19.png', 'forest2.png',
        'forest20.png', 'forest21.png', 'forest22.png', 'forest23.png', 'forest4.png', 'forest5.png',
        'water10.png', 'water11.png', 'water13.png', 'water14.png', 'water16.png', 'water17.png',
        'water18.png', 'water20.png', 'water7.png', 'water8.png'
    ],

    TRAIN_CARDS: [
        'train_Black-Hawk.png', 'train_blackbeard.png', 'train_che-guevara.png', 'train_Chief-Joseph.png',
        'train_christopher-columbus.png', 'train_Cochise.png', 'train_ernest-shackleton.png',
        'train_miyamoto-musashi.png', 'train_noh-master.png', 'train_pablo-picasso.png',
        'train_prince-shotoku.png', 'train_saito-hajime.png', 'train_Sir-Agravaine-the-Proud.png',
        'train_Sir-Bors-de-Ganis.png', 'train_Sir-Galahad-the-Pure.png', 'train_Sir-Gawain-of-Orkney.png',
        'train_Sir-Pellimore-the-Questing-Beast-Hunter.png', 'train_Sir-Tor-the-Bastard.png',
        'train_spartacus.png', 'train_sumo-champion.png', 'train_uesugi-kenshin.png',
        'train_v61.png', 'train_v62.png', 'train_v63.png', 'train_v68.png', 'train_v72.png',
        'train_v79.png', 'train_v84.png', 'train_v85.png', 'train_v86.png'
    ],

    BATTLE_CARDS: [
        'battle_v13_framed.png', 'battle_v18_framed.png', 'battle_v24_framed.png', 'battle_v26_framed.png',
        'battle_v27_framed.png', 'battle_v31_framed.png', 'battle_v37_framed.png', 'battle_v40_framed.png',
        'battle_v44_framed.png', 'battle_v47_framed.png', 'battle_v49_framed.png', 'battle_v50_framed.png',
        'battle_v59_framed.png', 'battle_v87_framed.png', 'battle_0163e65b-2d92-4926-bb40-30f3c29d95da_framed.png',
        'battle_05f90cb4-5bd4-4178-b54a-66155ee151a5_framed.png', 'battle_091ea3fa-9969-4e97-bfbb-9bf5e8bb33dd_framed.png',
        'battle_143c5ebf-afda-410e-ba2d-b79b0b392545_framed.png', 'battle_277161b6-6e85-476e-a608-5fb158966d3d_framed.png',
        'battle_431e5e6d-a02e-46e3-9754-7da6d5eb1d65_framed.png', 'battle_6251a85e-d747-4b22-b59d-1d4279640a67_framed.png',
        'battle_62a86f66-b74b-41c4-b619-435a29aa2627_framed.png', 'battle_74577e72-4e9f-4c5f-9881-fe79838c2934_framed.png',
        'battle_7706cdce-74b9-4278-be73-5928cab87111_framed.png', 'battle_81976493-a130-48aa-a2d4-55e597c85b34_framed.png',
        'battle_a5a936ce-dc0f-428d-a23d-9a162ab43f94_framed.png', 'battle_bd6c51e8-a3eb-4066-b907-1f7b256d1c04_framed.png',
        'battle_cc625161-ea24-41cd-8715-b176da86ed2d_framed.png', 'battle_e8973dcd-7f30-4d7f-8947-7539468f03ec_framed.png',
        'battle_ffcc41e9-6fd7-4753-a98b-d45cae15a2af_framed.png'
    ],

    BUILD_CARDS: [
        'build_100.png', 'build_105.png', 'build_113.png', 'build_119.png', 'build_133.png',
        'build_141.png', 'build_143.png', 'build_147.png', 'build_17.png', 'build_20.png',
        'build_24.png', 'build_25.png', 'build_28.png', 'build_29.png', 'build_51.png',
        'build_55.png', 'build_57.png', 'build_65.png', 'build_68.png', 'build_7.png',
        'build_76.png', 'build_78.png', 'build_8.png', 'build_83.png', 'build_84.png',
        'build_89.png', 'build_92.png', 'build_93.png', 'build_98.png', 'build_99.png'
    ]
};

// Image utility functions
const getRandomImage = (imageArray, usedImages = []) => {
    const availableImages = imageArray.filter(img => !usedImages.includes(img));
    if (availableImages.length === 0) return imageArray[0];
    return availableImages[Math.floor(Math.random() * availableImages.length)];
};

const getImagePath = (cardType, imageName) => {
    const basePath = CARD_IMAGE_PATHS[cardType.toUpperCase()];
    return `${basePath}${imageName}`;
};

let usedImages = { move: [], train: [], battle: [], build: [] };

const resetUsedImagesIfNeeded = (type) => {
    const maxImages = AVAILABLE_IMAGES[type.toUpperCase() + '_CARDS'].length;
    if (usedImages[type].length >= maxImages - 2) {
        usedImages[type] = [];
    }
};

// Rarity assignment function
function getRarityByTriangles(triangles) {
    if (triangles <= 2) return CARD_RARITIES.MYTHIC;
    if (triangles <= 3) return CARD_RARITIES.LEGENDARY;
    if (triangles <= 4) return CARD_RARITIES.EPIC;
    if (triangles <= 5) return CARD_RARITIES.RARE;
    if (triangles <= 6) return CARD_RARITIES.UNCOMMON;
    return CARD_RARITIES.COMMON;
}// Part 3: Exercise Data & Move Card Generation

export const MOVE_EXERCISES = [
    // Chest exercises (code: 'e')
    { name: 'Clapping Push-ups', exercise: 'ClappingPushUps', triangles: 2, code: 'e', difficulty: 'Advanced' },
    { name: 'Decline Push-ups', exercise: 'DeclinePushUps', triangles: 3, code: 'e', difficulty: 'Advanced' },
    { name: 'Diamond Push-ups', exercise: 'DiamondPushUps', triangles: 2, code: 'e', difficulty: 'Advanced' },
    { name: 'Dive Bombers', exercise: 'DiveBombers', triangles: 3, code: 'e', difficulty: 'Advanced' },
    { name: 'Hand Release Push-ups', exercise: 'HandReleasePushUps', triangles: 4, code: 'e', difficulty: 'Intermediate' },
    { name: 'Inchworm Push-ups', exercise: 'InchwormPushUps', triangles: 2, code: 'e', difficulty: 'Advanced' },
    { name: 'Pancake Push-ups', exercise: 'PancakePushUps', triangles: 3, code: 'e', difficulty: 'Advanced' },
    { name: 'Pendulum Push-ups', exercise: 'PendulumPushUps', triangles: 2, code: 'e', difficulty: 'Advanced' },
    { name: 'Pike Push-ups', exercise: 'PikePushUps', triangles: 3, code: 'e', difficulty: 'Intermediate' },
    { name: 'Push-ups', exercise: 'PushUps', triangles: 5, code: 'e', difficulty: 'Beginner' },
    { name: 'Close Push-ups', exercise: 'PushUpsClose', triangles: 3, code: 'e', difficulty: 'Intermediate' },
    { name: 'Spiderman Push-ups', exercise: 'PushUpsSpiderman', triangles: 2, code: 'e', difficulty: 'Advanced' },
    { name: 'Wide Push-ups', exercise: 'PushUpsWide', triangles: 4, code: 'e', difficulty: 'Intermediate' },
    { name: 'Rocking Horse Push-ups', exercise: 'RockingHorsePushUps', triangles: 2, code: 'e', difficulty: 'Advanced' },
    { name: 'Slow Push-ups', exercise: 'SlowPushUps', triangles: 3, code: 'e', difficulty: 'Intermediate' },
    { name: 'Spartan Push-ups', exercise: 'SpartanPushUps', triangles: 2, code: 'e', difficulty: 'Advanced' },
    { name: 'T Push-ups', exercise: 'TPushUps', triangles: 2, code: 'e', difficulty: 'Advanced' },

    // Back exercises (code: 'k')
    { name: 'Australian Pull-ups', exercise: 'AustralianPullUps', triangles: 4, code: 'k', difficulty: 'Intermediate' },
    { name: 'Back Extensions', exercise: 'BackExtensions', triangles: 5, code: 'k', difficulty: 'Beginner' },
    { name: 'Chin-ups', exercise: 'ChinUps', triangles: 2, code: 'k', difficulty: 'Advanced' },
    { name: 'Hyperextensions', exercise: 'Hyperextensions', triangles: 4, code: 'k', difficulty: 'Intermediate' },
    { name: 'Inverted Rows with Chairs', exercise: 'InvertedRowsWithChairs', triangles: 3, code: 'k', difficulty: 'Intermediate' },
    { name: 'Negative Pull-ups', exercise: 'NegativePullUps', triangles: 2, code: 'k', difficulty: 'Advanced' },
    { name: 'Pull-ups', exercise: 'PullUps', triangles: 1, code: 'k', difficulty: 'Advanced' },
    { name: 'Superman Rocks', exercise: 'SupermanRocks', triangles: 5, code: 'k', difficulty: 'Beginner' },

    // Shoulder exercises (code: 'h')
    { name: 'Handstand', exercise: 'Handstand', triangles: 1, code: 'h', difficulty: 'Advanced' },
    { name: 'Handstand Push-ups', exercise: 'HandstandPushUps', triangles: 1, code: 'h', difficulty: 'Expert' },
    { name: 'Pike Push-ups', exercise: 'PikePushUpsShoulders', triangles: 3, code: 'h', difficulty: 'Intermediate' },
    { name: 'Wall Handstand', exercise: 'WallHandstand', triangles: 2, code: 'h', difficulty: 'Advanced' },
    { name: 'Hindu Push-ups', exercise: 'HinduPushUps', triangles: 3, code: 'h', difficulty: 'Intermediate' },

    // Arm exercises (code: 'm')
    { name: 'Chair Dips', exercise: 'ChairDips', triangles: 4, code: 'm', difficulty: 'Intermediate' },
    { name: 'Tricep Dips', exercise: 'TricepDips', triangles: 3, code: 'm', difficulty: 'Intermediate' },
    { name: 'Bear Crawl', exercise: 'BearCrawl', triangles: 4, code: 'm', difficulty: 'Intermediate' },
    { name: 'Crab Walk', exercise: 'CrabWalk', triangles: 4, code: 'm', difficulty: 'Intermediate' },
    { name: 'Arm Circles', exercise: 'ArmCircles', triangles: 6, code: 'm', difficulty: 'Beginner' },
    { name: 'Cross Body Push-ups', exercise: 'CrossBodyPushUps', triangles: 2, code: 'm', difficulty: 'Advanced' },

    // Bicep exercises (code: 'i')
    { name: 'Bicep Holds', exercise: 'BicepHolds', triangles: 5, code: 'i', difficulty: 'Beginner' },
    { name: 'Reverse Plank', exercise: 'ReversePlank', triangles: 3, code: 'i', difficulty: 'Intermediate' },
    { name: 'Towel Bicep Curls', exercise: 'TowelBicepCurls', triangles: 4, code: 'i', difficulty: 'Intermediate' },

    // Tricep exercises (code: 't')
    { name: 'Diamond Push-ups', exercise: 'DiamondPushUpsTricep', triangles: 2, code: 't', difficulty: 'Advanced' },
    { name: 'Tricep Push-ups', exercise: 'TricepPushUps', triangles: 3, code: 't', difficulty: 'Intermediate' },
    { name: 'Overhead Tricep Stretch', exercise: 'OverheadTricepStretch', triangles: 6, code: 't', difficulty: 'Beginner' },
    { name: 'Reverse Dips', exercise: 'ReverseDips', triangles: 3, code: 't', difficulty: 'Intermediate' },

    // Leg exercises (code: 'g')
    { name: 'Squats', exercise: 'Squats', triangles: 6, code: 'g', difficulty: 'Beginner' },
    { name: 'Jump Squats', exercise: 'JumpSquats', triangles: 3, code: 'g', difficulty: 'Intermediate' },
    { name: 'Lunges', exercise: 'Lunges', triangles: 5, code: 'g', difficulty: 'Beginner' },
    { name: 'Single Leg Squats', exercise: 'SingleLegSquats', triangles: 1, code: 'g', difficulty: 'Advanced' },
    { name: 'Wall Sit', exercise: 'WallSit', triangles: 4, code: 'g', difficulty: 'Intermediate' },
    { name: 'Side Lunges', exercise: 'SideLunges', triangles: 5, code: 'g', difficulty: 'Beginner' },
    { name: 'Reverse Lunges', exercise: 'ReverseLunges', triangles: 4, code: 'g', difficulty: 'Intermediate' },
    { name: 'Step Ups', exercise: 'StepUps', triangles: 5, code: 'g', difficulty: 'Beginner' },
    { name: 'Bulgarian Split Squats', exercise: 'BulgarianSplitSquats', triangles: 2, code: 'g', difficulty: 'Advanced' },
    { name: 'Cossack Squats', exercise: 'CossackSquats', triangles: 2, code: 'g', difficulty: 'Advanced' },
    { name: 'Pistol Squats', exercise: 'PistolSquats', triangles: 1, code: 'g', difficulty: 'Expert' },
    { name: 'Duck Walk', exercise: 'DuckWalk', triangles: 3, code: 'g', difficulty: 'Intermediate' },

    // Abs exercises (code: 'a')
    { name: 'Plank', exercise: 'Plank', triangles: 4, code: 'a', difficulty: 'Beginner' },
    { name: 'Side Plank', exercise: 'SidePlank', triangles: 3, code: 'a', difficulty: 'Intermediate' },
    { name: 'Sit-ups', exercise: 'SitUps', triangles: 5, code: 'a', difficulty: 'Beginner' },
    { name: 'Crunches', exercise: 'Crunches', triangles: 6, code: 'a', difficulty: 'Beginner' },
    { name: 'Bicycle Crunches', exercise: 'BicycleCrunches', triangles: 4, code: 'a', difficulty: 'Intermediate' },
    { name: 'Russian Twists', exercise: 'RussianTwists', triangles: 4, code: 'a', difficulty: 'Intermediate' },
    { name: 'Mountain Climbers', exercise: 'MountainClimbers', triangles: 3, code: 'a', difficulty: 'Intermediate' },
    { name: 'Hollow Body Hold', exercise: 'HollowBodyHold', triangles: 3, code: 'a', difficulty: 'Intermediate' },

    // Calves exercises (code: 'v')
    { name: 'Calf Raises', exercise: 'CalfRaises', triangles: 6, code: 'v', difficulty: 'Beginner' },
    { name: 'Single Leg Calf Raises', exercise: 'SingleLegCalfRaises', triangles: 4, code: 'v', difficulty: 'Intermediate' },
    { name: 'Jump Rope', exercise: 'JumpRope', triangles: 5, code: 'v', difficulty: 'Beginner' },

    // Overall exercises (code: '!')
    { name: 'Burpees', exercise: 'Burpees', triangles: 2, code: '!', difficulty: 'Advanced' },
    { name: 'Star Jumps', exercise: 'StarJumps', triangles: 5, code: '!', difficulty: 'Beginner' },
    { name: 'Jumping Jacks', exercise: 'JumpingJacks', triangles: 6, code: '!', difficulty: 'Beginner' },
    { name: 'High Knees', exercise: 'HighKnees', triangles: 5, code: '!', difficulty: 'Beginner' }
];

function generateMoveCards() {
    const moveCards = {};

    MOVE_EXERCISES.forEach((exercise, index) => {
        const cardId = `move_${exercise.exercise.toLowerCase()}`;
        const muscleGroupName = MUSCLE_GROUPS.find(mg => mg.code === exercise.code)?.name || 'Unknown';

        resetUsedImagesIfNeeded('move');
        const randomImage = getRandomImage(AVAILABLE_IMAGES.MOVE_CARDS, usedImages.move);
        usedImages.move.push(randomImage);

        moveCards[cardId] = {
            id: cardId,
            cardNumber: null, // No card numbers as requested
            name: CARD_TYPES.MOVE, // Just card type, no exercise names
            type: CARD_TYPES.MOVE,
            rarity: getRarityByTriangles(exercise.triangles),
            triangles: exercise.triangles,
            category: muscleGroupName,
            difficulty: exercise.difficulty,
            exercise: exercise.exercise, // Keep internal reference for functionality
            muscleGroupCode: exercise.code,
            qrCode: `https://bumfit.com/exercises/${exercise.exercise.toLowerCase()}`,
            description: `A ${exercise.difficulty.toLowerCase()} ${muscleGroupName} move card`,
            image: getImagePath('MOVE', randomImage),
            videoUrl: `assets/videos/exercises/${exercise.exercise}.mp4`,
            instructions: `Perform with proper form for maximum effectiveness.`,
            bodyParts: [muscleGroupName],
            abilities: [`${exercise.difficulty} Level`, `${muscleGroupName} Focus`, `${exercise.triangles} Triangle${exercise.triangles > 1 ? 's' : ''}`],
            unlocked: true,
            minReps: 1,
            maxReps: exercise.triangles
        };
    });

    return moveCards;
}// Part 4: Main Battle Cards Data

export const BATTLE_CARDS = {
    // Special first trainer card
    1: {
        id: 1,
        cardNumber: null, // No card numbers as requested
        name: CARD_TYPES.TRAINER, // Just card type, no character names
        type: CARD_TYPES.TRAINER,
        rarity: CARD_RARITIES.LEGENDARY,
        attack: 85,
        defense: 75,
        health: 100,
        energy: 90,
        abilities: ['Training Expert', 'Motivation', 'Form Perfect'],
        description: 'An elite trainer specializing in comprehensive fitness routines.',
        image: getImagePath('TRAIN', AVAILABLE_IMAGES.TRAIN_CARDS[0]),
        portrait: getImagePath('TRAIN', AVAILABLE_IMAGES.TRAIN_CARDS[0]),
        category: 'Hero',
        unlocked: true,
        workoutSequences: ['aeg', 'mkt', 'bfh', 'viq', 'zjp', 'elt']
    },

    // Generate 29 more trainer cards
    ...Array.from({ length: 29 }, (_, i) => {
        const id = i + 2;

        resetUsedImagesIfNeeded('train');
        const randomImage = getRandomImage(AVAILABLE_IMAGES.TRAIN_CARDS, usedImages.train);
        usedImages.train.push(randomImage);

        return {
            [id]: {
                id,
                cardNumber: null, // No card numbers as requested
                name: CARD_TYPES.TRAINER, // Just card type
                type: CARD_TYPES.TRAINER,
                rarity: Object.values(CARD_RARITIES)[Math.floor(Math.random() * 6)],
                attack: 50 + Math.floor(Math.random() * 50),
                defense: 50 + Math.floor(Math.random() * 50),
                health: 70 + Math.floor(Math.random() * 50),
                energy: 60 + Math.floor(Math.random() * 40),
                abilities: ['Training Expert', 'Motivation', 'Form Perfect'],
                description: 'A professional trainer specializing in comprehensive fitness routines.',
                image: getImagePath('TRAIN', randomImage),
                portrait: getImagePath('TRAIN', randomImage),
                category: ['Bodyweight', 'Strength', 'Legendary'][Math.floor(Math.random() * 3)],
                unlocked: Math.random() > 0.3,
                workoutSequences: ['aeg', 'mkt', 'bfh']
            }
        };
    }).reduce((acc, curr) => ({ ...acc, ...curr }), {}),

    // Add all move cards
    ...generateMoveCards(),

    // Generate 30 battle cards
    ...Array.from({ length: 30 }, (_, i) => {
        const id = `battle_${String(i + 1).padStart(3, '0')}`;

        resetUsedImagesIfNeeded('battle');
        const randomImage = getRandomImage(AVAILABLE_IMAGES.BATTLE_CARDS, usedImages.battle);
        usedImages.battle.push(randomImage);

        const topLeft = 1 + Math.floor(Math.random() * 5);
        const topRight = 1 + Math.floor(Math.random() * 3);
        const bottomLeft = 5 + Math.floor(Math.random() * 10);
        const bottomRight = 2 + Math.floor(Math.random() * 8);

        return {
            [id]: {
                id,
                cardNumber: null, // No card numbers as requested
                name: CARD_TYPES.BATTLE, // Just card type
                type: CARD_TYPES.BATTLE,
                rarity: Object.values(CARD_RARITIES)[Math.floor(Math.random() * 6)],
                topLeft,
                topRight,
                bottomLeft,
                bottomRight,
                health: topLeft + topRight + bottomLeft + bottomRight,
                abilities: ['Battle Fury', 'Combat Expert', 'Tactical Strike'],
                description: 'A powerful warrior ready to test your combat skills.',
                image: getImagePath('BATTLE', randomImage),
                category: ['Warrior', 'Shadow', 'Beast', 'Elemental'][Math.floor(Math.random() * 4)],
                unlocked: true
            }
        };
    }).reduce((acc, curr) => ({ ...acc, ...curr }), {}),

    // Generate 30 build cards
    ...Array.from({ length: 30 }, (_, i) => {
        const id = `build_${String(i + 1).padStart(3, '0')}`;

        resetUsedImagesIfNeeded('build');
        const randomImage = getRandomImage(AVAILABLE_IMAGES.BUILD_CARDS, usedImages.build);
        usedImages.build.push(randomImage);

        return {
            [id]: {
                id,
                cardNumber: null, // No card numbers as requested
                name: CARD_TYPES.BUILD, // Just card type
                type: CARD_TYPES.BUILD,
                rarity: Object.values(CARD_RARITIES)[Math.floor(Math.random() * 6)],
                targetCategory: ['strength', 'cardio', 'flexibility', 'core'][Math.floor(Math.random() * 4)],
                repCost: 2 + Math.floor(Math.random() * 6),
                effect: 'Force opponent to use specialized exercises',
                description: 'A specialized trainer who targets specific fitness areas.',
                image: getImagePath('BUILD', randomImage),
                category: ['Strength Focus', 'Cardio Focus', 'Core Focus'][Math.floor(Math.random() * 3)],
                unlocked: true,
                forcedSequence: ['emk', 'gva', 'aht'][Math.floor(Math.random() * 3)]
            }
        };
    }).reduce((acc, curr) => ({ ...acc, ...curr }), {})
};// Part 5: Helper Functions & Exports

// Basic card retrieval functions
export const getCardById = (id) => BATTLE_CARDS[id];
export const getCardByNumber = (cardNumber) => Object.values(BATTLE_CARDS).find(card => card.cardNumber === cardNumber);
export const getMoveCardByExercise = (exerciseName) => Object.values(BATTLE_CARDS).find(card => card.type === CARD_TYPES.MOVE && card.exercise === exerciseName);

// Card filtering functions
export const getCardsByType = (type) => Object.values(BATTLE_CARDS).filter(card => card.type === type);
export const getMoveCards = () => getCardsByType(CARD_TYPES.MOVE);
export const getTrainCards = () => getCardsByType(CARD_TYPES.TRAINER);
export const getBuildCards = () => getCardsByType(CARD_TYPES.BUILD);
export const getBattleCards = () => getCardsByType(CARD_TYPES.BATTLE);
export const getMoveCardsByMuscleGroup = (muscleGroupCode) => getMoveCards().filter(card => card.muscleGroupCode === muscleGroupCode);
export const getCardsByCategory = (category) => Object.values(BATTLE_CARDS).filter(card => card.category === category);
export const getCardsByRarity = (rarity) => Object.values(BATTLE_CARDS).filter(card => card.rarity === rarity);
export const getUnlockedCards = () => Object.values(BATTLE_CARDS).filter(card => card.unlocked);
export const getAllCards = () => Object.values(BATTLE_CARDS);

// Game mode filtering
export const getCardsForGameMode = (gameMode) => {
    const allCards = getAllCards();
    switch (gameMode) {
        case GAME_MODES.ONLINE:
            return allCards.filter(card => card.type === CARD_TYPES.TRAINER || card.type === CARD_TYPES.BUILD || card.type === CARD_TYPES.BATTLE);
        case GAME_MODES.OFFLINE:
            return allCards.filter(card => card.type === CARD_TYPES.MOVE || card.type === CARD_TYPES.BUILD || card.type === CARD_TYPES.BATTLE);
        case GAME_MODES.HYBRID:
            return allCards;
        default:
            return allCards;
    }
};

// Move card specific functions
export const getMoveCardTriangles = (moveCard) => {
    if (moveCard.type !== CARD_TYPES.MOVE) return 0;
    return moveCard.triangles || 1;
};

export const calculateMoveCardReps = (moveCard, chosenReps, roundMultiplier = 1) => {
    if (moveCard.type !== CARD_TYPES.MOVE) return 0;
    const maxReps = getMoveCardTriangles(moveCard);
    const validReps = Math.min(Math.max(1, chosenReps), maxReps);
    return validReps * roundMultiplier;
};

// Battle system functions
export const calculateBattleScore = (attackerCard, defenderCard) => {
    if (attackerCard.type === CARD_TYPES.BATTLE && defenderCard.type === CARD_TYPES.BATTLE) {
        const attackPower = attackerCard.bottomLeft || attackerCard.attack || 0;
        const defensePower = defenderCard.topLeft || defenderCard.defense || 0;
        return Math.max(0, attackPower - defensePower);
    } else {
        const attackPower = attackerCard.attack + (attackerCard.energy * 0.1);
        const defensePower = defenderCard.defense + (defenderCard.health * 0.05);
        return Math.max(0, attackPower - defensePower);
    }
};

export const getBattleCardHealth = (battleCard) => {
    if (battleCard.type === CARD_TYPES.BATTLE) {
        return (battleCard.topLeft || 0) + (battleCard.topRight || 0) + (battleCard.bottomLeft || 0) + (battleCard.bottomRight || 0);
    }
    return battleCard.health || 0;
};

// Utility functions
export const isCardUnlocked = (cardId) => {
    const card = getCardById(cardId);
    return card ? card.unlocked : false;
};

export const getRepMultiplier = (round) => Math.max(1, round);

export const getDifficultyInfo = (difficulty) => DIFFICULTY_LEVELS[difficulty] || DIFFICULTY_LEVELS['Beginner'];

// Muscle group functions
export const getMuscleGroupName = (code) => {
    const muscleGroup = MUSCLE_GROUPS.find(mg => mg.code === code);
    return muscleGroup ? muscleGroup.name : 'Unknown';
};

export const getMuscleGroupCode = (name) => {
    const muscleGroup = MUSCLE_GROUPS.find(mg => mg.name.toLowerCase() === name.toLowerCase());
    return muscleGroup ? muscleGroup.code : null;
};

export const getAvailableMuscleGroups = () => {
    const moveCards = getMoveCards();
    const groups = [...new Set(moveCards.map(card => card.muscleGroupCode))];
    return groups.map(code => ({
        code,
        name: getMuscleGroupName(code),
        count: moveCards.filter(card => card.muscleGroupCode === code).length
    }));
};

// Workout generation functions
export const generateRandomWorkout = (muscleGroupCodes, exercisesPerGroup = 1) => {
    const workout = [];
    muscleGroupCodes.forEach(code => {
        const availableCards = getMoveCardsByMuscleGroup(code);
        if (availableCards.length > 0) {
            const shuffled = [...availableCards].sort(() => 0.5 - Math.random());
            const selected = shuffled.slice(0, exercisesPerGroup);
            workout.push(...selected);
        }
    });
    return workout;
};

export const generateWorkoutFromSequence = (sequence) => {
    const workout = [];
    for (let char of sequence) {
        const availableCards = getMoveCardsByMuscleGroup(char);
        if (availableCards.length > 0) {
            const randomCard = availableCards[Math.floor(Math.random() * availableCards.length)];
            workout.push(randomCard);
        }
    }
    return workout;
};

// Statistics functions
export const getCardStats = () => {
    const allCards = getAllCards();
    const moveCards = getMoveCards();
    return {
        total: allCards.length,
        moveCards: moveCards.length,
        trainCards: getTrainCards().length,
        battleCards: getBattleCards().length,
        buildCards: getBuildCards().length,
        muscleGroups: getAvailableMuscleGroups().length,
        difficulties: {
            Beginner: moveCards.filter(card => card.difficulty === 'Beginner').length,
            Intermediate: moveCards.filter(card => card.difficulty === 'Intermediate').length,
            Advanced: moveCards.filter(card => card.difficulty === 'Advanced').length,
            Expert: moveCards.filter(card => card.difficulty === 'Expert').length
        },
        triangleDistribution: {
            1: moveCards.filter(card => card.triangles === 1).length,
            2: moveCards.filter(card => card.triangles === 2).length,
            3: moveCards.filter(card => card.triangles === 3).length,
            4: moveCards.filter(card => card.triangles === 4).length,
            5: moveCards.filter(card => card.triangles === 5).length,
            6: moveCards.filter(card => card.triangles === 6).length,
            7: moveCards.filter(card => card.triangles === 7).length
        }
    };
};

// Image and asset functions
export const getCardBackImage = (cardType) => `${CARD_IMAGE_PATHS.BACKS}${cardType.toLowerCase()}_back.png`;

export const preloadCardImages = async () => {
    const allCards = getAllCards();
    const imagePromises = allCards.map(card => {
        return new Promise((resolve) => {
            const img = new Image();
            img.onload = () => resolve(true);
            img.onerror = () => resolve(false);
            img.src = card.image;
        });
    });
    return Promise.all(imagePromises);
};

export const refreshImageAssignments = () => {
    usedImages = { move: [], train: [], battle: [], build: [] };
    const newMoveCards = generateMoveCards();
    Object.keys(newMoveCards).forEach(key => {
        BATTLE_CARDS[key] = newMoveCards[key];
    });
    return getAllCards();
};

// Development logging (only shows in development mode)
if (typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'development') {
    console.log('🃏 BUMFIT Cards Database Loaded');
    console.log(`📊 Total Cards: ${Object.keys(BATTLE_CARDS).length}`);
    console.log('ℹ️ Note: Cards display types only, no individual names or numbers');
}